<template>
  <div id="mb-gallery" class="mb-gallery">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: setMainImageValue(startGameConfig.mainImage.width, 1920) + 'px',
        height: setMainImageValue(startGameConfig.mainImage.height, 1080) + 'px',
        top: setMainImageValue(startGameConfig.mainImage.pos.y, 0) + 'px',
        left: setMainImageValue(startGameConfig.mainImage.pos.x, 0) + 'px',
      }"
    />
    <div class="current-image" :style="{ width: items.length * 1920 + 'px', left: '-' + currentIndex * 1920 + 'px' }">
      <!-- <img v-if="currentImg" :src="giveMeImagePlease(currentImg.src)" /> -->
      <div
        class="current-image-box"
        v-for="(it, itemIndex) in items"
        :key="'images-' + itemIndex"
        :style="setStyle(it.src)"
      >
        <img draggable="false" :src="giveMeImagePlease(it.src)" />
      </div>
    </div>
    <div class="gallery-images">
      <div
        @click="
          currentImg = it;
          currentIndex = itemIndex;
        "
        class="img-box"
        v-for="(it, itemIndex) in items"
        :key="'images-' + itemIndex"
        :style="setStyle(itemIndex)"
      >
        <img draggable="false" :src="giveMeImagePlease(it.src)" />
      </div>
    </div>
    <transition name="img-fade">
      <div v-if="items.length > 1 && currentIndex > 0" class="prv-icon" @click="prv()">
        <svg width="calc(1080px * 0.1)" id="prv" height="calc(1080px * 0.1)" viewBox="0 0 400 400">
          <g>
            <rect fill="transparent" height="402" width="402" y="-1" x="-1" />
          </g>
          <g>
            <ellipse
              id="svg_9"
              :stroke="'rgba(255,255,255,1)'"
              :fill="'rgba(255,255,255,1)'"
              ry="156"
              rx="156"
              cy="199"
              cx="199"
              fill-opacity="0"
              stroke-width="29"
            />
            <path
              id="svg_12"
              class="path"
              :stroke="'rgba(255,255,255,1)'"
              d="m135.228828,260.427728l60.44279,-60.442457l-60.44279,-60.442891l34.546114,-34.542387l94.996235,94.985278l-94.996235,95.014748"
              stroke-opacity="0"
              stroke-width="11"
              :fill="'rgba(255,255,255,1)'"
            />
          </g>
        </svg>
      </div>
    </transition>
    <transition name="img-fade">
      <div v-if="items.length > 1 && currentIndex + 1 < items.length" class="next-icon" @click="next()">
        <svg width="calc(1080px * 0.1)" id="next" height="calc(1080px * 0.1)" viewBox="0 0 400 400">
          <g>
            <rect fill="transparent" height="402" width="402" y="-1" x="-1" />
          </g>
          <g>
            <ellipse
              id="svg_9"
              :stroke="'rgba(255,255,255,1)'"
              ry="156"
              rx="156"
              cy="199"
              cx="199"
              fill-opacity="0"
              stroke-width="29"
              :fill="'rgba(255,255,255,1)'"
            />
            <path
              class="path"
              id="svg_12"
              d="m135.228828,260.427728l60.44279,-60.442457l-60.44279,-60.442891l34.546114,-34.542387l94.996235,94.985278l-94.996235,95.014748"
              stroke-opacity="0"
              stroke-width="11"
              :fill="'rgba(255,255,255,1)'"
              :stroke="'rgba(255,255,255,1)'"
            />
          </g>
        </svg>
      </div>
    </transition>
  </div>
</template>
<script>
import defaultMixin from '../../mixins/defaultMixin';
import _ from 'lodash';
import { Howler } from 'howler';
export default {
  name: 'mb-gallery',
  components: {},
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      items: [],
      currentImg: null,
      currentIndex: 0,
      nextIconHover: false,
      prvIconHover: false,
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    next() {
      if (this.currentIndex + 1 < this.items.length) this.currentIndex = this.currentIndex + 1;
    },
    prv() {
      if (this.currentIndex > 0) this.currentIndex = this.currentIndex - 1;
    },
    setStyle(itemIndex) {
      // if (this.currentImg) {
      if (itemIndex == this.currentIndex) return { opacity: 1 };
      // }
    },
    setValue(items, id, it) {
      this.$set(items, id, it);
    },
    setMainImageValue(value, defaultValue) {
      if (value) return value;
      else return defaultValue;
    },
    init() {
      this.items = _.cloneDeep(this.startGameConfig.images);
      this.currentImg = this.items[0];
    },
    cancelCheck() {
      this.gameState = false;
      this.$store.commit('CHANGE_CHECK_SWITCH', false);
    },
    resetGameAction() {},
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    randomNumber(x, n) {
      return Math.floor(Math.random() * x) + n;
    },
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  beforeDestroy() {
    Howler.stop();
  },
  computed: {
    titleIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/title-64px.png`);
      } catch {
        console.log(
          '%cTitleIcon MbGallery- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    titleIconOn() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/title-on-64px.png`);
      } catch {
        console.log(
          '%cTitleIconOn MbGallery- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 1030px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.curtain
  position: absolute
  top: 0
  width: 1920px
  height: 1080px
  left: 0
  z-index: 2
.mb-gallery
  background-size: contain
  background-repeat: no-repeat
  position: relative
  left: $backgroundOffsetLeft
  overflow: hidden
  height: 100%
  width: 100%
  .current-image
    width: 100%
    height: 90%
    position: absolute
    top: 0
    left: 0
    display: flex
    align-items: center
    flex-direction: row
    justify-content: flex-start
    transition: .5s
    .current-image-box
      width: 1920px
      height: calc(1080px - 15%)
      display: flex
      align-items: center
      flex-direction: row
      justify-content: center
      img
        border: 10px white solid
        box-shadow: 0px 0px 16px rgba(0,0,0, 0.4)
        max-width: 90%
        max-height: 90%
        object-fit: scale-down
  .gallery-images
    width: 100%
    height: 10%
    position: absolute
    bottom: 10px
    left: 0
    display: flex
    align-items: center
    flex-direction: row
    justify-content: center
    .img-box
      // margin-top: 125px
      display: flex
      align-items: center
      flex-direction: row
      justify-content: center
      max-width: 192px
      height: 100%
      opacity: .5
      transition: .5s
      cursor: pointer
      img
        border: 3px white solid
        box-shadow: 0px 0px 16px rgba(0,0,0, 0.4)
        max-width: 90%
        max-height: 90%
        object-fit: scale-down
      &:hover
        margin-top: 0
        opacity: 1
  .next-icon
    right: 10px

  .prv-icon
    left: 10px
  .next-icon, .prv-icon
    width: 100px
    height: 100px
    transition: .5s
    animation: .5s .3s iconShow 1 linear backwards
    margin: 0
    padding: 0
    position: absolute
    z-index: 4
    top: calc(50% - 50px)
    cursor: pointer
    opacity: .5
    &:hover
      opacity: 1

  #prv, #next
    animation: none


@keyframes iconShow
  0%
    opacity: 0
    // transform: rotate(-25deg) scale(.9)
  100%
    opacity: 1
.img-fade-leave-active, .img-fade-enter-active
  transition: all .5s linear
.img-fade-leave-to, .img-fade-enter
  opacity: 0
.img-check-fade-leave-active
  transition: all .1s .5s linear
.img-check-fade-enter-active
  transition: all .3s linear
.img-check-fade-leave-to, .img-check-fade-enter
  opacity: 0
</style>
